import React, { useMemo } from 'react';
import { useField } from 'react-final-form';

import { DeleteOutlined, EastOutlined, WestOutlined } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import { useSetCurrentBlockId } from '@wp-block-builder/editor/hooks';
import { type TBlock } from '@wp-block-builder/package';
import { useEditableBlockInput, useEditableBlocksArrayField } from '@wp-block-builder/views/EditableMessage/hooks';
import { alertInfo, removeSnackbarAlert } from '@wp-react/notifications';

import AddMenuButton from '../AddBlockButton/blocks/Container';

import TuneMenuButton from './TuneMenuButton';
import TuneMenuDivider from './TuneMenuDivider';
import TuneMenuLayout from './TuneMenuLayout';

type Props = {
  name: string;
  parentBlockName: string;
};
export default function ColumnTuneMenu({ parentBlockName, name }: Props) {
  const { value: blocksValue, swap } = useEditableBlocksArrayField(`${parentBlockName}.props.blocks`);
  const { value: columnsCount } = useField(`${parentBlockName}.props.columnsCount`, { defaultValue: 3 }).input;
  const { value, onChange } = useEditableBlockInput(name);
  const index = useMemo(() => blocksValue.indexOf(value), [value, blocksValue]);
  const block = useField<TBlock>(name).input.value;
  const setCurrentBlockId = useSetCurrentBlockId();

  return (
    <TuneMenuLayout placement="top">
      <TuneMenuButton
        placement="top"
        tooltipTitle="Delete"
        disabled={block.type === 'ContainerYield'}
        onClick={() => {
          if (block.type === 'ContainerYield') {
            return;
          }
          onChange(AddMenuButton.defaultColumnBlock());
          setCurrentBlockId(null);
          const onUndoClick = () => {
            onChange(value);
            setCurrentBlockId(value.id);
            removeSnackbarAlert();
          };
          alertInfo(
            <Stack direction="row" spacing={3} alignItems="center">
              <Typography color="inherit">Block deleted</Typography>
              <Button onClick={onUndoClick} sx={{ color: 'inherit' }}>
                Undo
              </Button>
            </Stack>
          );
        }}
      >
        <DeleteOutlined fontSize="small" />
      </TuneMenuButton>
      <TuneMenuDivider placement="top" />
      <TuneMenuButton
        placement="top"
        tooltipTitle="Move left"
        disabled={index === 0}
        onClick={() => {
          swap(index, index - 1);
        }}
      >
        <WestOutlined fontSize="small" />
      </TuneMenuButton>
      <TuneMenuButton
        placement="top"
        tooltipTitle="Move right"
        disabled={index + 1 === columnsCount}
        onClick={() => {
          swap(index, index + 1);
        }}
      >
        <EastOutlined fontSize="small" />
      </TuneMenuButton>
    </TuneMenuLayout>
  );
}
